function getVolatilityByCode(code) {
  switch (code) {
    case 'very_low':
      return 'Low'
    case 'low':
      return 'Low-Mid';
    case 'moderate':
      return 'Medium';
    case 'high':
      return 'Mid-High';
    case 'very_high':
      return 'High';
    default:
      return "?";
  }
}

function GameInfoItem({
  title,
  iconSrc,
  value
}) {
  return (
    <>
      <div className="game-info__title">{title}</div>
      <div className="game-info__value">
        {iconSrc && <img src={iconSrc} />}
        {value}
      </div>
    </>
  );
}

function GameInfo({
  game,
  isVisible
}) {
  return (
    <div className={`game-info ${isVisible ? 'is-visible' : ''}`}>
      <img className="game-info__bg" src="/image/games/game-info-bg.svg" />
      <div className="game-info__grid">
        <GameInfoItem title="Volatility" value={getVolatilityByCode(game.volatility ?? '?')} iconSrc="/image/games/pepper-icon.svg" />
        <GameInfoItem title="Rows x Reels" value={game.grid ?? '?'} />
        <div className="game-info__row-line"></div>
        <GameInfoItem title="Multiplier" value={`x${game.multiplier ?? '?'}`} iconSrc="/image/games/bullet-icon.svg" />
        <GameInfoItem title="Paylines" value={game.paylines ?? '?'} />
      </div>
    </div>
  )
}

export default GameInfo;
